// extracted by mini-css-extract-plugin
export default {"hideTooltip":"V9-z","fadeIn":"W9-z","delay":"X9-z","recommendedSizeTooltip":"Y9-z"};